export default {
  productNotFound: 'PRODUCT_NOT_FOUND',
  productNotPublished: 'PRODUCT_NOT_PUBLISHED',
};
